import * as R from 'ramda';

import { setInDefaultValue } from 'decorators';
import { throwSubmissionError } from 'utils';

function setDefaultInitialValuesHandler({ match }) {
  const { token } = match.params;

  return R.pipe(setInDefaultValue(token, 'token'));
}

function mapBillingToAddressFields(data) {
  if (!data || !data.appraisalPayment) return data;

  const { appraisalPayment } = data;

  const addressParts = [
    appraisalPayment.billingStreetAddress,
    appraisalPayment.billingCity,
    appraisalPayment.billingStateCode,
    appraisalPayment.billingPostalCode,
  ].filter(Boolean);

  const fullAddress = addressParts.join(', ');

  return {
    ...data,
    appraisalPayment: {
      ...appraisalPayment,
      address: fullAddress || undefined,
      streetName: appraisalPayment.billingStreetAddress,
      municipality: appraisalPayment.billingCity,
      stateCode: appraisalPayment.billingStateCode,
      postalCode: appraisalPayment.billingPostalCode,
      countryCode: appraisalPayment.billingCountryCode,
      province: appraisalPayment.billingProvince,
    },
  };
}

function mergeInitialValuesHandler({ setDefaultInitialValues, setInitialValues }) {
  return R.pipe(
    mapBillingToAddressFields,
    setDefaultInitialValues,
    setInitialValues,
  );
}

function mapAddressToBillingFields(data) {
  if (!data || !data.appraisalPayment) return data;

  const { appraisalPayment } = data;

  return {
    ...data,
    appraisalPayment: {
      ...appraisalPayment,
      billingStreetAddress: appraisalPayment.address || appraisalPayment.billingStreetAddress,
      billingCity: appraisalPayment.municipality || appraisalPayment.billingCity,
      billingStateCode: appraisalPayment.stateCode || appraisalPayment.billingStateCode,
      billingPostalCode: appraisalPayment.postalCode || appraisalPayment.billingPostalCode,
      billingCountryCode: appraisalPayment.countryCode || appraisalPayment.billingCountryCode,
      billingProvince: appraisalPayment.province || appraisalPayment.billingProvince,
      address: undefined,
      streetName: undefined,
      municipality: undefined,
      stateCode: undefined,
      postalCode: undefined,
      countryCode: undefined,
      province: undefined,
    },
  };
}

function onSubmitHandler({ createAppraisalPayment, setSuccessTrue }) {
  return R.pipe(
    mapAddressToBillingFields,
    createAppraisalPayment,
    R.then(setSuccessTrue),
    R.otherwise(throwSubmissionError),
  );
}

export {
  setDefaultInitialValuesHandler as setDefaultInitialValues,
  mergeInitialValuesHandler as mergeInitialValues,
  onSubmitHandler as onSubmit,
};
